import { rgObjectToDto } from "./index195.js";
import { strToU8, zlibSync } from "fflate";
function CompressRgObject(obj) {
	return zlibSync(strToU8(JSON.stringify(rgObjectToDto(obj))), { level: 9 });
}
export { CompressRgObject };

//# sourceMappingURL=index197.js.map